import { render, staticRenderFns } from "./arrowGo.vue?vue&type=template&id=6836f4d5&"
import script from "./arrowGo.vue?vue&type=script&lang=js&"
export * from "./arrowGo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports